
import React from 'react';
import styled from '@emotion/styled';

import { mq, text, green01 } from '../../_style';

export default class ArticleItemName extends React.Component {
  render() {
    const Container = styled.h2`
      padding-bottom: 30px;
      ${mq.pc} {
        ${text('26px', (38/26))}
      }
      ${mq.sp} {
        ${text('26px', (36/26))}
      }
    `;
    return(
      <Container>{this.props.children}</Container>
    )
  }
}
